import React from "react";
import { Button } from "@thebouqs/button";
export function DrawerHandle(props) {
  var {
    children
  } = props;
  return /*#__PURE__*/React.createElement(Button, props, children != null ? children : "X");
}
//# sourceMappingURL=DrawerHandle.js.map